var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.441,
    height: 56.441,
    viewBox: "0 0 56.441 56.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(-317.238 -3816.127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3_copy",
    "data-name": "Rectangle 3 copy",
    width: 56.441,
    height: 56.441,
    rx: 15,
    transform: "translate(317.238 3816.127)",
    fill: "#59be3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(330.183 3828.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M25.52,10.142H20.479l.3-1.183a6.264,6.264,0,0,0-2.6-6.719A3.556,3.556,0,0,0,12.9,3.879l-.6,1.505A20.126,20.126,0,0,1,8.71,11.2a4.711,4.711,0,0,0-2.952-1.055A4.758,4.758,0,0,0,1,14.9v9.517a4.743,4.743,0,0,0,8.548,2.855,6.671,6.671,0,0,0,4.684,1.9h7.084a6.108,6.108,0,0,0,4.349-1.8,13.179,13.179,0,0,0,3.886-9.382V14.173a4.035,4.035,0,0,0-4.03-4.03ZM5.758,26a1.586,1.586,0,0,1-1.586-1.586V14.9a1.586,1.586,0,1,1,3.172,0v9.517A1.586,1.586,0,0,1,5.758,26Zm20.62-8.011a10.031,10.031,0,0,1-2.957,7.138A2.957,2.957,0,0,1,21.315,26H14.231a3.531,3.531,0,0,1-2.512-1.04l-1.2-1.2V14.9a4.733,4.733,0,0,0-.089-.88,23.316,23.316,0,0,0,4.814-7.455l.6-1.51a.371.371,0,0,1,.243-.225.39.39,0,0,1,.328.048,3.087,3.087,0,0,1,1.28,3.31L16.9,11.341a1.586,1.586,0,0,0,1.543,1.973H25.52a.86.86,0,0,1,.858.858Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedThumb);
export default __webpack_public_path__ + "static/media/checkedThumb.3ab46f235be4591cd24db094a4446707.svg";
export { ForwardRef as ReactComponent };